import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  EXPENSES_EDIT,
  EXPENSES_UPDATE,
  EXPENSE_CATEGORY_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { EXPENSE_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";

const parseFormDate = (value) => {
  if (!value) return "";
  const m = moment(
    value,
    [
      "DD/MM/YYYY",
      "YYYY-MM-DD",
      "DD/MM/YYYY hh:mm A",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss",
    ],
    true,
  );
  return (m.isValid() ? m : moment(value)).format("YYYY-MM-DD");
};

const ExpenseEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    const formData = new FormData();
    formData.append("expense_category_id", form.expense_category_id);
    formData.append("amount", form.amount);
    formData.append(
      "date",
      moment(form.date, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD"),
    );
    formData.append("notes", form.notes || "");
    if (form.attachments?.length) {
      Array.from(form.attachments).forEach((file) => {
        formData.append("attachments", file);
      });
    }
    axios
      .put(EXPENSES_UPDATE + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(EXPENSE_UPDATED);
          navigate("/expenses");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(EXPENSES_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          setForm({
            expense_category_id: d.expense_category_id,
            category_selected: d.expense_category_id
              ? {
                  value: Number(d.expense_category_id),
                  label: d.expense_category_name,
                }
              : null,
            amount: d.amount ?? "",
            date: parseFormDate(d.date),
            notes: d.notes || "",
            attachments_existing: d.attachments || [],
          });
        }
      })
      .finally(() => setLoading(false));

    axios.get(EXPENSE_CATEGORY_LIST_DROPDOWN).then((res) => {
      if (res.status === 200 && res.data.success) {
        setCategoryOptions(res.data.data || []);
      }
    });
  }, [id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Expenses</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/expenses"}>
                    <span>Expenses List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Expense</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/expenses"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="expense_category_id"
                        >
                          Category<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="expense_category_id"
                          options={categoryOptions}
                          placeholder="Select Category"
                          value={form.category_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              expense_category_id: selected?.value,
                              category_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage
                          error={errors}
                          name="expense_category_id"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="amount">
                          Amount<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="amount"
                          placeholder="Amount"
                          value={form.amount ?? ""}
                          onChange={(e) =>
                            setForm({ ...form, amount: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="amount" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="date">
                          Date<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          id="date"
                          className="form-control"
                          placeholder="Select Date"
                          value={form.date || ""}
                          options={{ dateFormat: "Y-m-d" }}
                          onChange={(dates) =>
                            setForm({
                              ...form,
                              date: dates[0]
                                ? moment(dates[0]).format("YYYY-MM-DD")
                                : "",
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="date" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="notes">
                          Notes
                        </label>
                        <textarea
                          className="form-control"
                          id="notes"
                          placeholder="Notes"
                          rows={3}
                          value={form.notes || ""}
                          onChange={(e) =>
                            setForm({ ...form, notes: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="notes" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="attachments">
                          Attachments
                        </label>
                        {form.attachments_existing?.length > 0 && (
                          <div className="d-flex flex-wrap mb-2 gap-2">
                            {form.attachments_existing.map((file, idx) => (
                              <a
                                key={idx}
                                href={file}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-sm btn-outline-primary d-flex align-items-center"
                              >
                                <i className="bx bx-paperclip me-1"></i>
                                Attachment {idx + 1}
                              </a>
                            ))}
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          id="attachments"
                          name="attachments"
                          multiple
                          onChange={(e) =>
                            setForm({
                              ...form,
                              attachments: e.target.files,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="attachments" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/expenses"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseEdit;
